// Lib
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from '@mui/material'
import { useSelector, useDispatch } from 'react-redux'
import { Form, useFormikContext } from 'formik'
import _ from 'lodash'

// Images
import deleteSVG from 'images/commons/delete.svg'
import closeSVG from 'images/commons/close.svg'

// Include in project
import styles from './index.module.scss'
import { Button, SelectSingle, TextField } from 'component'
import type { RootState } from 'states/store'
import { setOpenDialog } from 'states/slice/modalDialog'
import { ETransformationDataToServer } from 'utils/tranformData'
import { useHandleActionMasterData } from 'hooks'

interface Props {
  openModal: boolean
  closeModal: () => void
  refetchProvinceList: any
  refetchProvinceTrashList: any
  createProvince: any
  updateProvince: any
  deleteProvince: any
}

const ModalOfProvince: React.FC<Props> = (props: Props): JSX.Element => {
  const { values, errors, handleSubmit } = useFormikContext<any>()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const getZoneListReducer = useSelector((state: RootState) => state.zone)

  const { handleUpdate, handleDelete } = useHandleActionMasterData({
    errors,
    values,
    createMasterData: props.createProvince,
    updateMasterData: props.updateProvince,
    typeUpdateMasterData: ETransformationDataToServer.UpdateProvince,
    deleteMasterData: props.deleteProvince,
    refetchMasterData: props.refetchProvinceList,
    refetchMasterDataTrashList: props.refetchProvinceTrashList,
    closeModal: props.closeModal,
    key: 'provinceID',
  })

  return (
    <Modal open={props.openModal} onClose={props.closeModal}>
      <Form className={styles.containerModal}>
        <div className={styles.section}>
          {values.formInput.provinceID ? (
            <h3>{t('provinceManagement.titleModelOld')}</h3>
          ) : (
            <h3>{t('provinceManagement.titleModelNew')}</h3>
          )}
          <img className={styles.closeIcon} src={closeSVG} alt="closeSVG" onClick={props.closeModal} />
        </div>
        <TextField name={`formInput.provinceCode`} type="text" label="Province Code" require />
        <TextField name={`formInput.provinceName`} type="text" label="Province Name" require />
        <SelectSingle
          name={'formInput.zoneID'}
          option={getZoneListReducer.zoneListOption}
          disabled={false}
          label="Zone"
          require
        />
        <div className={styles.rowButton}>
          {values.formInput.provinceID && (
            <div className={styles.button}>
              <Button
                typeButton="button"
                type={'outline'}
                disabled={false}
                name={t<string>('common.delete')}
                icon={deleteSVG}
                fullWidth
                functionOnClick={() =>
                  dispatch(
                    setOpenDialog({
                      title: t<string>('provinceManagement.deleteTitle'),
                      description: t<string>('provinceManagement.deleteDescription'),
                      status: 'danger',
                      functionOnSubmit: handleDelete,
                    }),
                  )
                }
              />
            </div>
          )}
          <div className={styles.button}>
            <Button
              typeButton="submit"
              type={'primary'}
              disabled={false}
              name={t<string>('common.save')}
              fullWidth
              functionOnClick={() => {
                handleSubmit()
                handleUpdate()
              }}
            />
          </div>
        </div>
      </Form>
    </Modal>
  )
}

export default ModalOfProvince
